import './EditListForm.scss'

import React, { useState, useCallback, useEffect } from 'react'
import { useForm, useWatch } from 'react-hook-form'
import { useDispatch } from 'react-redux'

import { Field, LabelText, Label, Input, TextArea, Button, Icon, ErrorMessage } from 'hb4e-ui-core-ui'
import { useAnalytics } from 'hb4e-ui-analytics'

import { updateList } from '../../../../actions'
import { listsPageType } from '../../../../constants'

export const EditListForm = ({ onClose, list }) => {
  const dispatch = useDispatch()
  const [isSubmitting, setIsSubmitting] = useState(false)
  const nameMaxCharacters = 80
  const { trackPageLoad } = useAnalytics()

  const {
    register,
    handleSubmit,
    setError,
    control,
    trigger,
    formState: { errors },
  } = useForm({
    mode: 'onChange',
    reValidateMode: 'onChange',
    defaultValues: {
      name: list.getName(),
      description: list.getDescription(),
    },
  })

  const onSubmit = useCallback(async ({ name, description }) => {
    try {
      setIsSubmitting(true)

      await dispatch(
        updateList({
          ...list,
          name: name,
          notes: description,
        }),
      )

      onClose()
    } catch (errors) {
      if (errors?.length === 0) {
        return
      }

      errors.forEach((error) => setError(error.fieldName, { type: 'server', message: error.errorMessage }))
    } finally {
      setIsSubmitting(false)
    }
  }, [])

  const remainingNameCharacters = nameMaxCharacters - useWatch({ control, name: 'name' }).length
  const listDescription = useWatch({ control, name: 'description' })

  // Analytics logic.
  useEffect(() => {
    trackPageLoad({
      pageType: listsPageType,
      pageName: 'List Edit Page',
    })
  }, [])

  return (
    <div className="edit-list-form">
      <form className="edit-list-form__form" onSubmit={handleSubmit(onSubmit)}>
        <Field isRequired={true} errors={errors.name}>
          <Label className="edit-list-form__list-name-text-area" htmlFor="edit-list-form-name">
            <LabelText>{`List Name (Characters Remaining: ${remainingNameCharacters})`}</LabelText>
            <Input
              required
              id="edit-list-form-name"
              name="name"
              {...register('name', {
                required: 'List Name is required.',
              })}
              maxLength={nameMaxCharacters}
            />
            <ErrorMessage />
          </Label>
        </Field>

        <Field>
          <Label className="edit-list-form__list-description-text-area" htmlFor="edit-list-form-description">
            <LabelText>Description</LabelText>
            <TextArea
              id="edit-list-form-description"
              name="description"
              maxLength={100}
              value={listDescription}
              {...register('description')}
            />
          </Label>
        </Field>

        <div className="edit-list-form__buttons-wrapper">
          <Button
            className="edit-list-form__submit-button"
            type="submit"
            theme="primary solid"
            isDisabled={isSubmitting}
            icon={isSubmitting ? <Icon.Rotate spin /> : null}
            onClick={() => trigger()}
          >
            Save
          </Button>
          <Button className="edit-list-form__cancel-button" type="button" theme="primary outline" onClick={onClose}>
            Cancel
          </Button>
        </div>
      </form>
    </div>
  )
}

export default EditListForm
